export const SignalFunctions = {
    correspondenceMessageRead: "CorrespondenceMessageRead",
    correspondenceMessageReadAll: "CorrespondenceMessageReadAll",
    onSubtaskCorrespondenceReply: "OnSubtaskCorrespondenceReply"
}